import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Inject, Injectable } from '@angular/core';
import { EnvConfig, Environment } from '@doc/core';
import { ApiUrls } from '../backoffice-urls';
import { BaseResponse, SubEventDeleteRequest, SubEventGetListRequest, SubEventGetListResponse, SubEventInsertRequest } from '../models';
import { Observable } from 'rxjs/internal/Observable';


@Injectable({
  providedIn: 'root'
})
export class TemplateService {

  private http = inject(HttpClient);
  private apiUrl: string;
  private baseUrl: string;

  constructor(
    @Inject(EnvConfig) private config: Environment
  ) {
    this.baseUrl = this.config.mockUrl;
    this.apiUrl = this.config.apiUrl;
  }

  createTemplate(body: any) {
    const link = this.apiUrl + ApiUrls.createMailTemplate;
    return this.http.post<BaseResponse>(link, body);
  }

  updateTemplate(id: number, body: any) {
    const link = this.apiUrl + ApiUrls.updateMailTemplate + '/' + id;
    return this.http.post<any>(link, body);
  }

  getTemplateById(id: any) {
    const link = this.apiUrl + ApiUrls.getMailTemplateById + '/' + id;
    return this.http.get<any>(link);
  }

  createTicketTemplate(body: any) {
    const link = this.apiUrl + ApiUrls.createTicketTemplate;
    return this.http.post<BaseResponse>(link, body);
  }

  updateTicketTemplate(body: any) {
    const link = this.apiUrl + ApiUrls.updateTicketTemplate;
    return this.http.post<BaseResponse>(link, body);
  }

  getTicketTemplateById(id: any) {
    const link = this.apiUrl + ApiUrls.getTicketTemplateById + '/' + id;
    return this.http.get<BaseResponse>(link);
  }

  getEmailConfiguration() {
    const link = this.apiUrl + ApiUrls.getEmailConfiguration;
    return this.http.get<any>(link);
  }

  updateEmailConfiguration(body: any) {
    const link = this.apiUrl + ApiUrls.updateEmailConfiguration;
    return this.http.post<BaseResponse>(link, body);
  }

  createPomReportTemplate(body: FormData) {
    const headers = new HttpHeaders({
      'content-type': 'multipart/form-data'
    });
    const link = this.apiUrl + ApiUrls.createPomReportTemplate;
    return this.http.post<BaseResponse>(link, body, { headers });
  }

  getAllPomReportTemplate(body: any) {
    const link = this.apiUrl + ApiUrls.getAllParticipantReportTemplate;
    return this.http.post<any>(link, body);
  }
  getAllSelectedTemplate() {
    const link = this.apiUrl + ApiUrls.getAllSelectedTemplate;
    return this.http.get<any>(link);
  }

  UpdateSelectedPRTemplate(body: any) {
    const link = this.apiUrl + ApiUrls.UpdateSelectedPRTemplate;
    return this.http.post<any>(link, body);
  }

  downloadTemplate(requestObject: any): Observable<any> {
    const url = this.apiUrl + ApiUrls.downloadTemplate;
    return this.http.post(url, requestObject, { responseType: 'blob' });
  }


  createTranslationTemplate(body: FormData) {
    const headers = new HttpHeaders({
      'content-type': 'multipart/form-data'
    });
    const link = this.apiUrl + ApiUrls.createTranslationTemplate;
    return this.http.post<BaseResponse>(link, body, { headers });
  }

  getAllTranslationTemplate(body: any) {
    const link = this.apiUrl + ApiUrls.getAllTranslationTemplate;
    return this.http.post<any>(link, body);
  }
  getAllSelectedTranslationTemplate() {
    const link = this.apiUrl + ApiUrls.getAllSelectedTranslationTemplate;
    return this.http.get<any>(link);
  }
  UpdateSelectedTranslationTemplate(body: any) {
    const link = this.apiUrl + ApiUrls.UpdateSelectedTranslationTemplate;
    return this.http.post<any>(link, body);
  }
  DeleteTranslationTemplate(id: number) {
    const link = this.apiUrl + ApiUrls.deleteTranslationTemplate + "/" + id;
    return this.http.post<any>(link, id);
  }

  DeleteParticipationTemplate(id: number) {
    const link = this.apiUrl + ApiUrls.deleteParticipantReportTemplate + "/" + id;
    return this.http.post<any>(link, id);
  }
}
